import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "commentsContainer" }
const _hoisted_2 = { class: "scrollListContainer" }
const _hoisted_3 = {
  key: 0,
  class: "emptyState"
}
const _hoisted_4 = { class: "avatar" }
const _hoisted_5 = { class: "comment-content" }
const _hoisted_6 = { class: "comment-meta" }
const _hoisted_7 = { class: "author" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "comment-body" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_comment_form = _resolveComponent("new-comment-form")!
  const _component_comment_text = _resolveComponent("comment-text")!
  const _component_icon_clip = _resolveComponent("icon-clip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modify)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_new_comment_form, {
                key: 0,
                modelValue: _ctx.vm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vm) = $event)),
                onAdd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('add', $event)))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.comments.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Nessun commento "))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.comments, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "comment",
              key: item.identifier
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.author.name.charAt(0).toUpperCase()), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.author.name), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$filters.date(item.createdOn, 'DD-MM-YYYY HH:mm')), 1),
                  (_ctx.$store.state.isSuperAdmin())
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn-delete",
                        onClick: ($event: any) => (_ctx.deleteComment(item))
                      }, "×", 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_comment_text, { comment: item }, null, 8, ["comment"]),
                  (item.attachments.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.attachments, (x, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "attachment-link"
                        }, [
                          _createElementVNode("a", {
                            href: x.publicUrl,
                            target: "_blank"
                          }, [
                            _createVNode(_component_icon_clip),
                            _createTextVNode(" " + _toDisplayString(x.filename), 1)
                          ], 8, _hoisted_11)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
    ])
  ]))
}